<template>
  <div class="home-page">
    <!-- 头部导航 -->
    <header class="header">
      <div class="container">
        <div class="logo">煜家通智能</div>
        <nav class="nav">
          <span>首页</span>
          <span>功能介绍</span>
          <span>APP远程控制</span>
          <span>联系我们</span>
        </nav>
      </div>
    </header>

    <!--  banner -->
    <section class="banner">
      <div class="container">
        <div class="text-box">
          <h1>智能环控 · 智慧养殖</h1>
          <p>
            温度 | 湿度 | 压差 | 二氧化碳<br>
            手机APP远程实时监控 & 手动自动双控制
          </p>
          <button class="btn" @click="downloadApp">立即体验</button>
        </div>
      </div>
    </section>

    <!-- 核心功能 -->
    <section class="func">
      <div class="container">
        <h2 class="title">核心控制功能</h2>
        <div class="func-list">
          <div class="item">
            <h3>🌡 温度控制</h3>
            <p>APP手动/自动调节<br>实时监测舍内温度</p>
          </div>
          <div class="item">
            <h3>💧 湿度控制</h3>
            <p>高精度采集<br>自动加湿、除湿</p>
          </div>
          <div class="item">
            <h3>🌪 压差控制</h3>
            <p>舍内外压差监测<br>防止倒灌与病菌传播</p>
          </div>
          <div class="item">
            <h3>🧪 CO₂监测</h3>
            <p>24小时浓度采集<br>超标自动报警</p>
          </div>
        </div>
      </div>
    </section>

    <!-- APP介绍 -->
    <section class="app">
      <div class="container">
        <h2 class="title">手机APP远程控制</h2>
        <div class="app-box">
          <div class="left">
            <h3>随时随地，一键管理</h3>
            <ul>
              <li>✅ APP手动控制温度</li>
              <li>✅ APP手动控制湿度</li>
              <li>✅ APP手动控制压差</li>
              <li>✅ APP手动控制二氧化碳</li>
              <li>✅ 实时数据查看</li>
              <li>✅ 异常自动报警</li>
            </ul>
          </div>
          <div class="right">
			 <img :src="require('@/assets/app_bg.jpg')" alt="app介绍" class="app-img" />
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <p>煜家通智能 © 版权所有</p>
        <p>专注智慧养殖环境控制 | 温度·湿度·压差·二氧化碳·智能监控</p>
		 <!-- 备案号 在这里 -->
		<p class="beian">豫ICP备2026005759号-1</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  },
   methods: {
      // APP下载
      downloadApp() {
        // 在这里换成你的 APP 下载地址
        window.open("https://www.txzn.top/app/znqsadapp_v1.0_release_0304.apk", "_blank");
      }
    }
};
</script>

<style scoped>
/* 全局 */
.container {
  width: 1200px;
  margin: 0 auto;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei";
}

/* 头部 */
.header {
  background: #0a4d92;
  color: #fff;
  padding: 20px 0;
}
.logo {
  font-size: 22px;
  font-weight: bold;
}
.nav {
  display: flex;
  gap: 30px;
}
.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* banner */
.banner {
  height: 500px;
  background: linear-gradient(to right, #0a4d92, #007bff);
  color: #fff;
  display: flex;
  align-items: center;
}
.text-box h1 {
  font-size: 40px;
  margin-bottom: 20px;
}
.text-box p {
  font-size: 18px;
  line-height: 2;
  margin-bottom: 30px;
}
.btn {
  background: #ffc107;
  color: #333;
  border: none;
  padding: 14px 40px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

/* 功能 */
.func {
  padding: 80px 0;
  background: #f5f7fa;
}
.title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 50px;
  color: #333;
}
.func-list {
  display: flex;
  gap: 25px;
}
.item {
  flex: 1;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 0 10px #00000010;
}
.item h3 {
  margin-bottom: 10px;
  color: #0a4d92;
}
.item p {
  color: #666;
  line-height: 1.7;
}

/* APP */
.app {
  padding: 80px 0;
  background: #eef5ff;
}
.app-box {
  display: flex;
  align-items: center;
  gap: 60px;
}
.left {
  flex: 1;
}
.left h3 {
  font-size: 24px;
  margin-bottom: 20px;
}
.left li {
  list-style: none;
  font-size: 16px;
  margin: 12px 0;
}
.right {
  flex: 1;
}
.app-img {
  width: 300px;
  height: 600px;
  background: #ddd;
  border-radius: 20px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666;
}

/* 底部 */
.footer {
  background: #222;
  color: #ccc;
  text-align: center;
  padding: 40px 0;
}
.footer p {
  margin: 6px 0;
}
</style>